import React, { PureComponent } from "react";
import "./PlatformWiseMediaBreakdown.scss";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import PlatformWiseMediaBreakdownCharts from "./PlatformWiseMediaBreakdownCharts";

import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import ChartIndexSelector from "../ChartsOptionsSidebar/ChartIndexSelector";
import NoData from "../NoData/NoData";
import html2canvas from "html2canvas";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as ArrowIcon } from "../../../../../assets/svg/chevron.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";

class PlatformWiseMediaBreakdown extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
            index: 0,
        };
        this.chartEl = React.createRef();
    }

    // filterData(data) {
    //     let allowedPlatforms = this.props.allPlatforms.map((plt) => plt.id);
    //     return data.filter((plt) => allowedPlatforms.includes(plt.name));
    // }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        if (!this.props.drilldown_charts) {
            let contextMenu = d3.select(".dashboard-charts-contextmenu");

            contextMenu.attr("data-type", "clickedMenu");
            contextMenu.style("top", `${y + 10}px`);
            contextMenu.style("left", `${x - 82}px`);
            contextMenu.style("background", `#fff`);
            contextMenu.style("color", `#1a1a1a`);
            contextMenu.html(null);
            contextMenu
                .append("li")
                .text("View Conversations")
                .on("click", () => {
                    self.handleContextMenuClick(chart);
                });
            !this.props.drilldown_charts &&
                contextMenu
                    .append("li")
                    .text("View Insights")
                    .on("click", () => {
                        // console.log('drilldown')
                        self.handleDrilldownClick(chart);
                        // this.props.showChartsDrilldown(true, "platformWiseMediaBreakdown");
                    });
            contextMenu.style("display", "block");
        }
    };

    createNewFilter(chart) {
        let newFilter = !this.props.drilldown_charts
            ? this.props.filters
                ? JSON.parse(JSON.stringify(this.props.filters))
                : {}
            : this.props.drilldown_filters.filter;
        newFilter.platforms = [chart.platformId];
        if (this.props.drilldown_charts) {
            if (newFilter.extras) newFilter.extras.push({ key: "post_media_type", value: chart.mediaType });
            else newFilter.extras = [{ key: "post_media_type", value: chart.mediaType }];
        } else newFilter.extras = [{ key: "post_media_type", value: chart.mediaType }];
        return newFilter;
    }

    handleContextMenuClick(chart) {
        let newFilter = this.createNewFilter(chart);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(chart) {
        let newFilter = this.createNewFilter(chart);

        this.props.handleDrilldownClick(newFilter);
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [["Platform", "Text", "Image", "Video"]];
        this.props.data.forEach((platform) => {
            let text = platform.medias.find((x) => x[0] === "text") || [0, 0];
            let image = platform.medias.find((x) => x[0] === "image") || [0, 0];
            let videos = platform.medias.find((x) => x[0] === "video") || [0, 0];
            let platformName = platform.platformName;
            let row = [platformName, text[1], image[1], videos[1]];
            csvFmt.push(row);
        }, this);

        downloadCSVData(csvFmt, this.props.widget.name);
    };

    onIndexChange = (index) => this.setState({ index });

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, {
            backgroundColor: options.background ? "#fff" : null,
            scrollX: 0,
            scrollY: this.props.drilldown_charts ? 50 : -window.scrollY,
        }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    increment = () => {
        if (this.props.data.length === 1) return;
        let index = (this.state.index + 1) % this.props.data.length;
        this.setState({ index });
    };

    decrement = () => {
        if (this.props.data.length === 1) return;
        let index = this.state.index;
        if (index === 0) index = this.props.data.length - 1;
        else index--;
        this.setState({ index });
    };

    getChart = () => {
        let data = JSON.parse(JSON.stringify(this.props.data[this.state.index]));
        let options = this.props.data.map((d, i) => ({ label: d.platformName, value: i }));

        return (
            <>
                <div className="chart-item-name">
                    <ChartIndexSelector
                        selectorType="Platform"
                        currentName={data.platformName}
                        currentIndex={this.state.index}
                        options={options}
                        onIndexChange={this.onIndexChange}
                        widgetContainerRef={this.props.widgetContainerRef}
                    />
                </div>

                <PlatformWiseMediaBreakdownCharts
                    data={data}
                    // resizedCount={this.props.resizedCount}
                    showLabel={this.props.showLabel}
                    showLegend={this.props.hideLegendPie}
                    widgetContainerRef={this.props.widgetContainerRef}
                    addContextMenuListener={this.addContextMenuListener}
                />
            </>
        );
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.length === 0) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="This chart shows a breakdown of conversation volume based on type of media in the post." />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata
                                    ? null
                                    : !this.props.drilldown_charts && (
                                          <Popup
                                              className="skiptranslate"
                                              trigger={
                                                  this.props.expandWidget ? (
                                                      <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  ) : (
                                                      <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  )
                                              }
                                              inverted
                                              content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                              size="mini"
                                              position="bottom center"
                                              style={{ zIndex: "99999" }}
                                          />
                                      )}
                            </>
                        }
                        {(this.props.isPublic && nodata) || this.props.drilldown_charts ? null : (
                            <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />}
                        {!nodata && <CustomCheckBox checked={this.props.hideLegendPie} onClick={this.props.changeHideLegendPie} label="Show Legends" />}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart dashboard-chart-slider" ref={this.container}>
                        <div
                            className={`chart-slider chart-slider-left ${this.props.data.length === 1 ? "disabled" : ""}`}
                            data-html2canvas-ignore
                            onClick={this.decrement}>
                            <ArrowIcon />
                        </div>
                        <div className="chart-area" ref={this.chartEl}>
                            {this.props.data && this.getChart()}
                        </div>
                        <div
                            className={`chart-slider chart-slider-right ${this.props.data.length === 1 ? "disabled" : ""}`}
                            data-html2canvas-ignore
                            onClick={this.increment}>
                            <ArrowIcon />
                        </div>
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
    drilldown_filters: state.dashboardReducer.drilldown_filters,
    maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
});

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlatformWiseMediaBreakdown);
